const InviteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      fill="none"
      viewBox="0 0 16 16"
    >
      <g clipPath="url(#clip0_4368_10498)">
      <path d="M5.99992 10.0002C5.99992 10.0002 6.74992 10.6668 7.99992 10.6668C9.24992 10.6668 9.99992 10.0002 9.99992 10.0002M11.9999 1.3335H3.99992C2.52716 1.3335 1.33325 2.5274 1.33325 4.00016V12.0002C1.33325 13.4729 2.52716 14.6668 3.99992 14.6668H11.9999C13.4727 14.6668 14.6666 13.4729 14.6666 12.0002V4.00016C14.6666 2.5274 13.4727 1.3335 11.9999 1.3335ZM11.3333 6.66683C11.3333 7.03502 11.0348 7.3335 10.6666 7.3335C10.2984 7.3335 9.99992 7.03502 9.99992 6.66683C9.99992 6.29864 10.2984 6.00016 10.6666 6.00016C11.0348 6.00016 11.3333 6.29864 11.3333 6.66683ZM5.99992 6.66683C5.99992 7.03502 5.70144 7.3335 5.33325 7.3335C4.96506 7.3335 4.66659 7.03502 4.66659 6.66683C4.66659 6.29864 4.96506 6.00016 5.33325 6.00016C5.70144 6.00016 5.99992 6.29864 5.99992 6.66683Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_4368_10498">
          <rect width="16" height="16" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  )
};

export default InviteIcon;
